import passkeyAppendAfterHybridSrc from '@corbado/shared-ui/assets/passkey-append-after-hybrid.svg';
import { memo, useRef } from 'react';
import React from 'react';
import { useIconWithTheme } from '../../../hooks/useIconWithTheme';
import { Icon } from './Icon';
export const PasskeyAppendAfterHybridIcon = memo(props => {
    const svgRef = useRef(null);
    const { logoSVG } = useIconWithTheme(svgRef, passkeyAppendAfterHybridSrc);
    return (React.createElement(Icon, { src: logoSVG, ref: svgRef, alt: 'passkey-append-after-hybrid', ...props }));
});
